import { useState } from 'react';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction, PieceAssetSize, PieceAssetType } from '@apiContract';

import { apiRequest } from '@src/api/apiRequest';
import { uploadImageToS3 } from '@src/api/imageS3';

import { getUploadUrl } from '@src/api/piece';

import { ActionComponentProps } from '../../index';
import { DialogSignatureConfirmation } from '../DialogSignatureConfirmation';

export const FinishDeliveryWithSignature = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const [actionInProgress, setActionInProgress] = useState<boolean>(false);

  const confirmAction = async (imageBase64: string) => {
    setActionInProgress(true);

    const { pieceAssets } = await getUploadUrl(mailpieces[0].id);

    const { url, key } =
        pieceAssets.find(
          (asset) =>
            asset.pieceAssetType === PieceAssetType.PickupSignature && asset.pieceAssetSize === PieceAssetSize.Large,
        ) || {};

    await apiRequest(
      uploadImageToS3,
      { image: imageBase64, uploadUrl: url, contentType: 'image/jpg' },
      false,
      5,
    );

    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.FinishDeliveryWithSignature,
      pickupSignatureKey: key,
    }).unwrap();

    onActionFinish();
    setActionInProgress(false);
  };

  return (
    <DialogSignatureConfirmation
      mailpieces={mailpieces}
      actionStarted={actionStarted}
      persist={actionInProgress || isLoading}
      onActionFinish={onActionFinish}
      onConfirm={confirmAction}
    />
  );
};
